import { omit } from 'lodash'
import { DateTime } from 'luxon'

import { TransactionFiltersState } from '../reducers/finances/transactionFiltersReducer'
import { FilteredTransactionsPayload } from '../v2-features/transactions/transactions.slice'
import { DATE_FORMATS_LUXON } from '../utils/dateHelpers'

export const transactionFilterToQueryUrlService = (
  transactionFilters: Partial<TransactionFiltersState> & { userId: number }
) => {
  const { startDate, endDate, sortVal, transactionsType, sortAsc } =
    transactionFilters

  const filters: FilteredTransactionsPayload = omit(
    transactionFilters,
    'startDate',
    'endDate'
  )

  if (startDate) {
    filters.startDate = DateTime.fromFormat(startDate, DATE_FORMATS_LUXON.INPUT)
  }

  if (endDate) {
    filters.endDate = DateTime.fromFormat(endDate, DATE_FORMATS_LUXON.INPUT)
  }

  if (transactionsType === 'excluded') {
    filters.includeSplitChildren = true
  }

  filters.sortName = sortVal

  if (sortAsc !== undefined) {
    filters.sortDirection = sortAsc ? 'asc' : 'desc'
  }

  return filters
}
